import React, {useCallback, useState, useEffect} from 'react';
import SMCModal from '../../components/core/SMCModal';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody'
import {useTranslation} from 'react-i18next';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import SMCButton from '../../components/Simple/SMCButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import SMCTextInput from '../../components/Simple/SMCTextInput';

function TextInputModal({
    isOpen = false,
    onRequestClose,
    onSuccess,
    title,
    textInputLabel,
    labelWidth,
    height,
    width
}) {
    const { t } = useTranslation();

    const [textInput, setTextInput] = useState('');

    const handleSubmit = useCallback(() => {
        onSuccess(textInput);
    }, [onSuccess, textInput]);

    // Reset values on open
    useEffect(() => {
        if (isOpen) {
            setTextInput('');
        }
    }, [isOpen]);

    return (
        <SMCModal
            isOpen={isOpen}
            width={width || 430}
            height={height || 200}
            title={title || 'Input'}
            onRequestClose={onRequestClose}
        >
            <SMCModalBody>
                <SMCTextInput
                    label={textInputLabel}
                    value={textInput}
                    onChange={e => setTextInput(e.target.value)}
                    labelWidth={labelWidth}
                />
            </SMCModalBody>
            <SMCModalButtonContainer
                left={
                    <SMCButton onClick={handleSubmit}>
                        <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                        {t('SMC_GEN_SUBMIT')}
                    </SMCButton>
                }
                right={
                    <SMCButton onClick={onRequestClose}>
                        <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                        {t('SMC_GEN_CLOSE')}
                    </SMCButton>
                }
            />
            {/* Floating windows */}
            
        </SMCModal>

    );
}

export default TextInputModal;